// extracted by mini-css-extract-plugin
export default {"error-message":"MessageCard_error-message__xakYF","error-message__text":"MessageCard_error-message__text__CsAB1"};